<template>
  <v-alert
    text
    color="deep-orange lighten-1"
    icon="mdi-alert-circle"
    border="left"
  >
    <slot></slot>
  </v-alert>
</template>

<script>
export default {
  name: 'WarningAlert'
}
</script>
